export default __webpack_public_path__ + "27ec2bfc7fdc8b2cd533a3eea0dd45a2.png";